<script>
export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		textareaIdentifier: {
			type: String,
			default: '',
		},
		val: {
			type: [String, Number],
			default: '',
		},
	},
};
</script>

<template>
	<div>
		<label
			class="block text-lg mb-2"
			:for="textareaIdentifier"
			>{{ label }}</label
		>
		<textarea
		class="w-full px-5 py-2 border border-gray-300 border-opacity-50 dark:bg-ternary-dark rounded-md shadow-sm text-md text-gray-700 dark:text-gray-200 focus:border-red-500 focus:ring-2 focus:ring-red-200"			:name="textareaIdentifier"
			:aria-label="textareaIdentifier"
			:placeholder="label"
			v-bind="$attrs"
			@input="$emit('update:val', $event.target.value)"
			cols="14"
			rows="6"
		></textarea>
	</div>
</template>

<style lang="scss" scoped></style>
